import Head from 'next/head';
import Link from 'next/link';

import { BuyForexHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{BuyForexHelpSEO.metaTitle}</title>
        <meta name="description" content={BuyForexHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={BuyForexHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://www.muthootfincorpone.com/help/forex/buy-forex/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Forex Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Buy Forex Currency
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Buy Forex Currency
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  How can I purchase Forex from Muthoot FinCorp ONE?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Muthoot FinCorp ONE offers all major and legally accepted
                    currencies. You can buy from our list of offered currencies
                    by logging in and choosing your preferred currency. You can
                    also schedule an appointment to get Forex at nearby Muthoot
                    FinCorp Forex branch and get your currency hassle-free at
                    the booked price.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What are the documents required to purchase Forex from Muthoot
                  FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    If you are an Indian resident, we would need to verify your
                    proof of address (Aadhar Card/Driving Licence/Passport/Voter
                    ID) along with KYC. Whereas, for foreign residents, they
                    need to submit their passport and VISA
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Can I choose the denomination for my Forex cash?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Currently we do not offer the option to select cash
                    denominations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
